import template from './patient.modal.html';
import _ from 'lodash';
import './patient.modal.scss';
import ModalFrame from './patient-frame/patient-frame';
import ModalName from './patient-modal-name/patient-modal-name';
import ModalEnableVideo from './patient-modal-enable-video/patient-modal-enable-video';
import ModalContinueWithoutVideo from './patient-modal-continue-without-video/patient-modal-continue-without-video';
import ModalContinueWithBlockedVideo from './patient-modal-continue-with-blocked-video/patient-modal-continue-with-blocked-video';
import patientCheckInModalService from './common/services/patient-check-in-modal-service';
import * as devices from '../../modules/devices';
import * as call from '../../modules/call';
import { VideoProviderEvents } from '../../providers/video';

export default angular
  .module('doxy.patient.modal', [
    ModalFrame,
    ModalName,
    ModalEnableVideo,
    ModalContinueWithoutVideo,
    ModalContinueWithBlockedVideo,
    patientCheckInModalService,
  ])
  .component('patientModal', {
    template,
    bindings: {
      room: '<',
      roomAdminCanUsePaidFeatures: '<',
      currentInstitution: '<',
    },
    controller: function (
      Browser,
      $rootScope,
      patientService,
      $ngRedux,
      $stateParams,
      notifications,
      notificationFactory,
      patientCheckInModalService,
      VideoProviderFactory,
      enableCameraErrorHandler
    ) {
      this.mapStateToThis = (state) => ({
        hasCameraAccess: devices.selectors.hasCameraAccess(state),
      });

      this.unsubscribeFromStore = $ngRedux.connect(this.mapStateToThis)(this);

      const onModalShowHandlerDestroy = $rootScope.$on(
        'patient.modal.show',
        function () {
          // Pass preview div element as payload when modal shows up
          $rootScope.$emit('patient.modal.show.box');
        }
      );

      this.$onInit = () => {
        $ngRedux.dispatch(call.actions.showSelfPreview());
      };

      this.$onDestroy = () => {
        onModalShowHandlerDestroy();
        this.unsubscribeFromStore();
      };

      this.patient = {
        username: $stateParams.username || '',
      };

      const checkIn = () => {
        notifications.closeAll();
        this.checkInPromise = patientCheckInModalService
          .checkIn({
            room: this.room,
            patient: this.patient,
            fromRoomId: $stateParams.fromRoomId,
          })
          .then(() => {
            if ($stateParams.transfer) {
              patientService.showSuccessfulTransferToast();
            }

            /**
             * Background mode/other tab issue in mobile devices
             * @description https://doxyme.atlassian.net/browse/PE-3819
             */
            if (Browser.isMobileScreen()) {
              notificationFactory.showCommon(
                'warning',
                'background-mode-warning'
              );
            }
          })
          .finally(() => {
            this.checkInPromise = null;
          });
      };
      this.isEnableCameraButtonClicked = false;

      this.onEnableCamera = () => {
        this.isEnableCameraButtonClicked = true;
        return VideoProviderFactory.activeProvider
          .enableWebcam()
          .then(() => {
            if (!this.hasCameraAccess) {
              this.onNoMediaAccess();
            }
          })
          .catch((err) => {
            VideoProviderFactory.activeProvider.once(
              VideoProviderEvents.LocalStream,
              checkIn
            );

            enableCameraErrorHandler.onPatientCheckIn(err);
            this.onVideoBlocked();
            throw err;
          });
      };

      this.onEnableWebcamAndCheckIn = () => {
        this.onEnableCamera().then(() => {
          checkIn();
        });
      };

      this.onCheckIn = () => {
        VideoProviderFactory.activeProvider.off(
          VideoProviderEvents.LocalStream,
          checkIn
        );
        checkIn();
      };

      this.currentStep = 'fillNameStep';

      this.onBack = () => {
        this.currentStep = 'fillNameStep';
      };

      this.onVideoBlocked = () => {
        $rootScope.$emit('patient.modal.continueWithoutCameraStep', false);
        this.currentStep = 'videoBlockedStep';
      };

      this.continueWithoutCamera = () => {
        $rootScope.$emit('patient.modal.continueWithoutCameraStep', false);
        this.currentStep = 'continueWithoutCameraStep';
      };

      this.onNoMediaAccess = () => {
        this.currentStep = 'enableCameraStep';
      };
    },
  }).name;
